import React from 'react';
import styles from './styles.module.scss';

export const Header = ({ children }) => (
  <div className={styles.header}>
    {children}
  </div>
);
